import { effects } from 'redux-saga'

import { makeSelectRequirements } from 'internal-components/src/redux/modules/product/selectors'

import { setData } from '../../modules/signupEdit/actions'
import { selectEditSignupWithExternals } from '../../modules/signupEdit/selectors'

export default function* setRealm() {
  const state = yield effects.select()
  const signupWithExternals = yield effects.call(
    selectEditSignupWithExternals,
    state,
  )

  if (signupWithExternals.signup.data.get('auth.realm')) {
    return
  }

  const selector = yield effects.call(makeSelectRequirements)
  const requirements = yield effects.call(selector, state, {
    offerId: signupWithExternals.signup.offer,
  })

  const authRequirement = requirements.find(
    r => r.requirement === 'authentication' && r.realms.size > 0,
  )
  if (authRequirement) {
    yield effects.put.resolve(
      setData('auth.realm', authRequirement.realms.first()),
    )
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/setRealm.js